var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverPhonePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1172 7.294C15.1172 6.31938 15.9073 5.5293 16.8819 5.5293H30.1172C31.0918 5.5293 31.8819 6.31938 31.8819 7.294V14.3528C31.8819 15.3274 31.0918 16.1175 30.1172 16.1175H26.8525H23.1935H20.1466H16.8819C15.9073 16.1175 15.1172 15.3274 15.1172 14.3528V7.294Z",
    stroke: "#6921C4",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 20.124V26.999C19.75 27.3305 19.6183 27.6485 19.3839 27.8829C19.1495 28.1173 18.8315 28.249 18.5 28.249H8.5C8.16848 28.249 7.85054 28.1173 7.61612 27.8829C7.3817 27.6485 7.25 27.3305 7.25 26.999V9.49902C7.25 9.1675 7.3817 8.84956 7.61612 8.61514C7.85054 8.38072 8.16848 8.24902 8.5 8.24902H11",
    stroke: "#6921C4",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.502 24.5V24.5137",
    stroke: "#FF6019",
    strokeWidth: 2.42647,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1172 9.94141H32.8819",
    stroke: "#6921C4",
    strokeWidth: 1.85294
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverPhonePay);
export default __webpack_public_path__ + "static/media/overPhonePay.e55671d0.svg";
export { ForwardRef as ReactComponent };